export default __webpack_public_path__ + "images/e5de6e8d08e08f46413e4d94b3ee254c-education_small.webp";